export default __webpack_public_path__ + "assets/b1b034b7a3458be334fb508876edce21/03.jpg";